<template>
  <div class="layout gap-2">
    <div
        v-for="(publicProfileId, index) in publicProfileIds"
        :key="index"
        class="layout-item is-6:t is-3:w">
      <ProCard
          :public-profile-id="publicProfileId"
          :pricingValue= "pricingValue"
          :index="index"
          @toggleSelection="$emit('toggleSelection', publicProfileId)"
          @updateTopPro="$emit('updateTopPro')"
      />
    </div>
  </div>
</template>

<script>

import ProCard from './ProCard/ProCard';

export default {
  name: 'pro-cards-container',
  components: {
    ProCard,
  },
  props: {
    publicProfileIds: {
      type: Array,
      required: true,
    },
    pricingValue: {
      type: Boolean,
      required: true,
    },
  },
};
</script>
